// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-AuditLogs-styles___modalTitle--twnhQ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 8px !important;
}

.components-AuditLogs-styles___modalCloseButton--EV0lt {
  margin-left: auto !important;
}

.components-AuditLogs-styles___detailTable--oZofX {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.components-AuditLogs-styles___detailRow--yz_9G {
  border-bottom: 1px solid #f0f0f0;
}

.components-AuditLogs-styles___detailRow--yz_9G:last-child {
    border-bottom: none;
  }

.components-AuditLogs-styles___detailLabel--QPwvt {
  padding: 8px 16px 8px 0;
  color: #666;
  font-weight: 600;
  white-space: nowrap;
  width: 140px;
  vertical-align: top;
}

.components-AuditLogs-styles___detailValue--uLjcC {
  padding: 8px 0;
  word-break: break-all;
}

.components-AuditLogs-styles___detailSection--xWFnV {
  margin-top: 20px;
}

.components-AuditLogs-styles___detailSectionTitle--wHNbB {
  margin: 0 0 8px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #999;
}

.components-AuditLogs-styles___detailPre--z_dor {
  margin: 0;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 4px;
  font-size: 12px;
  overflow: auto;
  max-height: 300px;
}

.components-AuditLogs-styles___sentinel--_XY0g {
  display: flex;
  justify-content: center;
  padding: 24px 0;
  min-height: 48px;
}

.components-AuditLogs-styles___endOfList--_QXcU {
  text-align: center;
  color: #999;
  font-size: 13px;
  padding: 16px 0;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./components/AuditLogs/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAKlC;;AAHE;IACE,mBAAmB;EACrB;;AAGF;EACE,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,SAAS;AACX","sourcesContent":[".modalTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-right: 8px !important;\n}\n\n.modalCloseButton {\n  margin-left: auto !important;\n}\n\n.detailTable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.detailRow {\n  border-bottom: 1px solid #f0f0f0;\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.detailLabel {\n  padding: 8px 16px 8px 0;\n  color: #666;\n  font-weight: 600;\n  white-space: nowrap;\n  width: 140px;\n  vertical-align: top;\n}\n\n.detailValue {\n  padding: 8px 0;\n  word-break: break-all;\n}\n\n.detailSection {\n  margin-top: 20px;\n}\n\n.detailSectionTitle {\n  margin: 0 0 8px;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #999;\n}\n\n.detailPre {\n  margin: 0;\n  padding: 12px;\n  background: #f5f5f5;\n  border-radius: 4px;\n  font-size: 12px;\n  overflow: auto;\n  max-height: 300px;\n}\n\n.sentinel {\n  display: flex;\n  justify-content: center;\n  padding: 24px 0;\n  min-height: 48px;\n}\n\n.endOfList {\n  text-align: center;\n  color: #999;\n  font-size: 13px;\n  padding: 16px 0;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalTitle": `components-AuditLogs-styles___modalTitle--twnhQ`,
	"modalCloseButton": `components-AuditLogs-styles___modalCloseButton--EV0lt`,
	"detailTable": `components-AuditLogs-styles___detailTable--oZofX`,
	"detailRow": `components-AuditLogs-styles___detailRow--yz_9G`,
	"detailLabel": `components-AuditLogs-styles___detailLabel--QPwvt`,
	"detailValue": `components-AuditLogs-styles___detailValue--uLjcC`,
	"detailSection": `components-AuditLogs-styles___detailSection--xWFnV`,
	"detailSectionTitle": `components-AuditLogs-styles___detailSectionTitle--wHNbB`,
	"detailPre": `components-AuditLogs-styles___detailPre--z_dor`,
	"sentinel": `components-AuditLogs-styles___sentinel--_XY0g`,
	"endOfList": `components-AuditLogs-styles___endOfList--_QXcU`
};
module.exports = ___CSS_LOADER_EXPORT___;
